import {autoinject, transient} from "aurelia-dependency-injection";
import {CustomerModel, CustomerRuleConfigParameterModel} from "../../../../../../models/customers/customer.models";
import {BaseRuleParameters} from "./base-rule-parameters";
import { LookupClientService } from "../../../../../../services/lookups/lookup-client.service";
import { EventAggregator } from "aurelia-event-aggregator";
import { CustomerService } from "../../../../../../services/modules/customer-client.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { BindingEngine } from "aurelia-binding";
import { I18N } from "aurelia-i18n";
import { useView } from "aurelia-framework";

@autoinject
@transient()
@useView('views/pages/modules/customers/steps/rule-parameters/customer-rule-parameters.html')
export class CustomerRuleParameters extends BaseRuleParameters<CustomerRuleConfigParameterModel> {
    id: number;
    customer: CustomerModel;

    constructor(lookupService:LookupClientService, eventAggregator: EventAggregator, private customerService:CustomerService,
        dialogClientServices:DialogClientService, i18n:I18N, bindingEngine: BindingEngine){
        super(lookupService, eventAggregator, dialogClientServices, i18n, bindingEngine);
    }

    async activate(args: {
        id: string | number,
        customer: CustomerModel,
        idsToInclude: number[]
    }) {
        this.id = Number(args.id);
        this.customer = args.customer;
        const response = await this.customerService.getCustomerRuleParameters(this.customer.customerId);
        await super.activate(args, response.parameters, "customerRuleConfigParameterId");     
    }

    getODataUrl(): string {
        return "CustomerRuleConfigParameters";
    }
}
 